// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JvIHr{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.C9g8h{width:36px;height:27px;margin-right:12px;color:#5d6466}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `JvIHr`,
	"icon": `C9g8h`
};
module.exports = ___CSS_LOADER_EXPORT___;
